import {
  FILTERS_ARE_LOADING,
  FILTERS_LOADED_WITH_ERROR,
  FILTERS_ARE_LOADED,
  FILTER_SUCCESS_MESSAGE_RAISED,
  FILTER_FAILURE_MESSAGE_RAISED,
  FILTER_MESSAGES_RESTARTED,
  SET_CURRENT_FILTER,
  REGULATORY_STREAM_LOADED_WITH_ERROR,
  REGULATORY_STREAM_ARE_LOADING,
  REGULATORY_STREAM_ARE_LOADED,
  DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM,
  TOP_5_PUBLISHERS_ARE_LOADING,
  TOP_5_PUBLISHERS_LOADED_WITH_ERROR,
  TOP_5_PUBLISHERS_ARE_LOADED,
  TOP_5_COUNTRIES_LOADED_WITH_ERROR,
  TOP_5_COUNTRIES_ARE_LOADING,
  TOP_5_COUNTRIES_ARE_LOADED,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED,
  GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR,
  GRAPH_AGGREGATION_ARE_LOADING,
  GRAPH_AGGREGATION_ARE_LOADED,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADING,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADED,
  GET_DOCUMENT_IS_LOADED_WITH_ERROR,
  GET_DOCUMENT_IS_LOADING,
  GET_DOCUMENT_IS_LOADED,
  GET_SIMILAR_DOCUMENT_IS_LOADED,
  GET_SIMILAR_DOCUMENT_IS_LOADING,
  GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR,
  FILTERS_TYPES_ARE_LOADING,
  FILTERS_TYPES_ARE_LOADED,
  FILTERS_TYPES_LOADED_WITH_ERROR,
  ADD_NEWS_ITEM,
  EDIT_NEWS_ITEM,
  GENERATE_NEWS_ITEM,
  REGULATORY_STREAM_ARE_CLEAN,
} from "./actionTypes";

import {
  GET_FILTERS,
  ADD_FILTER,
  DELETE_FILTER,
  DELETE_NEWS_BY_ID,
  GET_REGULATORY_STREAM,
  GET_TOP_5_PUBLISHER,
  GET_TOP_5_COUNTRIES,
  GET_HOT_TOPICS_PER_BUSINESS,
  GET_GRAPH_AGGREGATION,
  GET_GRAPH_AGGREGATION_DETAILS,
  GET_DOCUMENT,
  GET_SIMILAR_DOCUMENT,
  GET_FILTERS_TYPE,
  BOOKMARK_DOCUMENT,
  UNBOOKMARK_DOCUMENT,
  CHECK_BOOKMARKING,
  ADD_NEWS,
  EDIT_NEWS,
  GENERATE_NEWS,
} from "../constants/urls";

import axios from "axios";
// import { addArrayAction } from "./newsListActions";

export function getFilter(usertoken, topic_id) {
  return (dispatch) => {
    dispatch(filtersAreLoading());
    axios({
      url: GET_FILTERS,
      params: {
        usertoken,
        topic_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(filtersAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          filtersAreLoadedWithError(err.response ? err.response.data : err)
        );
      });
  };
}

export function getFilterTypes(usertoken) {
  return (dispatch) => {
    dispatch(filtersTypesAreLoading());
    axios({
      url: GET_FILTERS_TYPE,
      params: {
        usertoken,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(filtersTypesAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          filtersTypesAreLoadedWithError(err.response ? err.response.data : err)
        );
      });
  };
}

export function getRegulatoryStream(
  usertoken,
  topic_id,
  freeText,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits,
  page,
  size,
  sortField,
  sortDirection
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);

  const params = {
    topic_id,
    publicationTypes,
    fromDate,
    toDate,
    publisherTypes,
    countries,
    // sortField,
    // sortField: sortField
    //   ? sortField
    //   : sessionStorage.getItem("sortField")
    //   ? sessionStorage.getItem("sortField")
    //   : "",
    sortField: sessionStorage.getItem("sortField")
      ? sessionStorage.getItem("sortField")
      : "",
    sortDirection,
    topic_search_tags: topicTags.length ? topicTags.join(";") : "",
  };
  const finalParams = Object.fromEntries(
    Object.entries(params).filter(([v]) => !!v)
  );
  return (dispatch) => {
    dispatch(regulatoryStreamsAreLoading(page));
    axios({
      url: GET_REGULATORY_STREAM,
      params: {
        usertoken,
        freeText,
        page,
        size,
        ...finalParams,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        // let finalArray = [];
        // response.data.RegHub_response.forEach((regulatoryStream) => {
        //   if (regulatoryStream.found_dates && regulatoryStream.found_dates[0]) {
        //     regulatoryStream.found_date =
        //       regulatoryStream.found_dates[0].description;
        //   }
        //   finalArray.push(regulatoryStream);
        // });

        dispatch(regulatoryStreamsAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          regulatoryStreamsAreLoadedWithError({
            filterFailureMessage: err.response ? err.response.data : err,
            page,
          })
        );
      });
  };
}

export function getTop5Publisher(
  usertoken,
  freeText,
  topic_id,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);
  return (dispatch) => {
    dispatch(top5PublishersAreLoading());
    axios({
      url: GET_TOP_5_PUBLISHER,
      params: {
        usertoken,
        topic_id,
        freeText,
        topic_search_tags: topicTags.length ? topicTags.join(";") : "",
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(top5PublishersAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          top5PublishersAreLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function getTop5Countries(
  usertoken,
  freeText,
  topic_id,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);

  return (dispatch) => {
    dispatch(top5CountriesAreLoading());
    axios({
      url: GET_TOP_5_COUNTRIES,
      params: {
        usertoken,
        topic_id,
        freeText,
        topic_search_tags: topicTags.length ? topicTags.join(";") : "",
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
        num_results: 5,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(top5CountriesAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          top5CountriesAreLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function getGraphAggregations(
  usertoken,
  freeText,
  topic_id,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);

  return (dispatch) => {
    dispatch(graphAggregationsAreLoading());
    axios({
      url: GET_GRAPH_AGGREGATION,
      params: {
        usertoken,
        topic_id,
        freeText,
        topic_search_tags: topicTags.length ? topicTags.join(";") : "",
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        let firstArray = [{ type: "date", label: "" }, ""],
          finalArray = [],
          graphAggregationsTotalAmount = 0;

        finalArray.push(firstArray);

        if (
          response.data &&
          response.data.RegHub_response &&
          response.data.RegHub_response[0] &&
          response.data.RegHub_response[0].length
        ) {
          response.data.RegHub_response[0].forEach((instance) => {
            let littleArray = [new Date(instance)];

            finalArray.push(littleArray);
          });
        } else {
          finalArray = [];
        }
        if (
          response.data &&
          response.data.RegHub_response &&
          response.data.RegHub_response[1] &&
          response.data.RegHub_response[1].length &&
          response.data.RegHub_response[0] &&
          response.data.RegHub_response[0].length
        ) {
          response.data.RegHub_response[1].forEach((instance, index) => {
            finalArray[index + 1].push(instance);
            graphAggregationsTotalAmount += instance;
          });
        }
        dispatch(
          graphAggregationsAreLoaded(finalArray, graphAggregationsTotalAmount)
        );
      })
      .catch((err) => {
        dispatch(
          graphAggregationsAreLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function getGraphAggregationsDetails(
  usertoken,
  freeText,
  topic_id,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);

  return (dispatch) => {
    dispatch(graphAggregationsDetailsAreLoading());
    axios({
      url: GET_GRAPH_AGGREGATION_DETAILS,
      params: {
        usertoken,
        freeText,
        topic_id,
        topic_search_tags: topicTags.length ? topicTags.join(";") : "",
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
        topicsAndUnits,
      },
    })
      .then((response) => {
        dispatch(
          graphAggregationsDetailsAreLoaded(
            response.data.RegHub_response,
            response.data.RegHub_response.length
          )
        );
      })
      .catch((err) => {
        dispatch(
          graphAggregationsDetailsAreLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function getHotTopicsPerBusiness(
  usertoken,
  freeText,
  topic_id,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topicsAndUnits
) {
  const topicTags = [topic_search_tags, topicsAndUnits].filter(Boolean);

  return (dispatch) => {
    dispatch(hotTopicsAndBusinessUnitsAreLoading());
    axios({
      url: GET_HOT_TOPICS_PER_BUSINESS,
      params: {
        usertoken,
        topic_id,
        freeText,
        topic_search_tags: topicTags.length ? topicTags.join(";") : "",
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(hotTopicsPerBusinessAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          hotTopicsPerBusinessAreLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function getDocument(usertoken, reference_id, topic_id) {
  return (dispatch) => {
    dispatch(getDocumentIsLoading());
    axios({
      url: GET_DOCUMENT,
      params: {
        usertoken,
        reference_id,
        topic_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(getDocumentIsLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          getDocumentIsLoadedWithError(err.response ? err.response.data : err)
        );
      });
  };
}

export function getSimilarDocument(usertoken, reference_id) {
  return (dispatch) => {
    dispatch(getDocumentIsLoading());
    axios({
      url: GET_SIMILAR_DOCUMENT,
      params: {
        usertoken,
        reference_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        // response.data.RegHub_response.forEach(
        //   (similarDocument) =>
        //     (similarDocument.news_date = formatDate(
        //       new Date(similarDocument.news_date),
        //       "dd.mm.yyyy"
        //     ))
        // );

        dispatch(getSimilarDocumentIsLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          getSimilarDocumentIsLoadedWithError(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function addFilter(
  usertoken,
  filter_name,
  topic_id,
  filter_search_value,
  filter_audience
) {
  return (dispatch) => {
    axios({
      url: ADD_FILTER,
      params: {
        usertoken,
        filter_name,
        topic_id,
        filter_search_value,
        filter_audience,
      },
    })
      .then((response) => {
        dispatch(filterSuccessMessageRaised(response.data));
        dispatch(getFilter(usertoken, topic_id));
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function deleteFilter(usertoken, filter_id, topic_id) {
  return (dispatch) => {
    axios({
      url: DELETE_FILTER,
      params: {
        usertoken,
        filter_id,
      },
    })
      .then((response) => {
        dispatch(filterSuccessMessageRaised(response.data));
        dispatch(getFilter(usertoken, topic_id));
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function deleteNewsById(usertoken, news_id) {
  return (dispatch) => {
    axios({
      url: DELETE_NEWS_BY_ID,
      params: {
        usertoken,
        news_id,
      },
    })
      .then((response) => {
        dispatch(deleteNewsByIdFromRegulatoryStream(news_id));
        dispatch(
          filterSuccessMessageRaised(
            response?.data || "The news has been deleted successfully."
          )
        );
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function addNewsItem(
  usertoken,
  newsTitle,
  description,
  content,
  country,
  url,
  publicationType,
  publisher,
  publisherType,
  publicationDate,
  curated,
  topics
) {
  return (dispatch) => {
    axios({
      url: ADD_NEWS,
      params: {
        usertoken,
        news_title: newsTitle,
        description,
        content,
        country,
        url,
        publication_type: publicationType,
        publisher,
        publisher_type: publisherType,
        publication_date: publicationDate,
        curated,
        topics,
      },
    })
      .then((response) => {
        dispatch(addNewsItemAction(response.data.RegHub_response));
        dispatch(
          filterSuccessMessageRaised("The news has been added successfully.")
        );
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function editNewsItem(
  newsId,
  usertoken,
  newsTitle,
  description,
  content,
  country,
  url,
  publicationType,
  publisher,
  publisherType,
  publicationDate,
  curated,
  topics
) {
  return (dispatch) => {
    axios({
      url: EDIT_NEWS,
      params: {
        news_id: newsId,
        usertoken,
        news_title: newsTitle,
        description,
        content,
        country,
        url,
        publication_type: publicationType,
        publisher,
        publisher_type: publisherType,
        publication_date: publicationDate,
        curated,
        topics,
      },
    })
      .then((response) => {
        dispatch(editNewsItemAction(response.data.RegHub_response));
        dispatch(
          filterSuccessMessageRaised("The news has been edited successfully.")
        );
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function addNewsItemAction(news) {
  return {
    type: ADD_NEWS_ITEM,
    news,
  };
}

export function editNewsItemAction(news) {
  return {
    type: EDIT_NEWS_ITEM,
    news,
  };
}

export function filtersAreLoading() {
  return {
    type: FILTERS_ARE_LOADING,
  };
}

export function filtersAreLoaded(filters) {
  return {
    type: FILTERS_ARE_LOADED,
    filters,
  };
}

export function filtersAreLoadedWithError(filterFailureMessage) {
  return {
    type: FILTERS_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function filtersTypesAreLoading() {
  return {
    type: FILTERS_TYPES_ARE_LOADING,
  };
}

export function filtersTypesAreLoaded(filtersTypes) {
  return {
    type: FILTERS_TYPES_ARE_LOADED,
    filtersTypes,
  };
}

export function filtersTypesAreLoadedWithError(filterFailureMessage) {
  return {
    type: FILTERS_TYPES_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function regulatoryStreamsAreLoadedWithError(payload) {
  return {
    type: REGULATORY_STREAM_LOADED_WITH_ERROR,
    payload,
  };
}

export function regulatoryStreamsAreLoading(page) {
  return {
    type: REGULATORY_STREAM_ARE_LOADING,
    page,
  };
}

export function regulatoryStreamsAreLoaded(regulatoryStream) {
  return {
    type: REGULATORY_STREAM_ARE_LOADED,
    regulatoryStream,
  };
}

export function deleteNewsByIdFromRegulatoryStream(newsId) {
  return {
    type: DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM,
    newsId,
  };
}

export function regulatoryStreamsAreClean() {
  return {
    type: REGULATORY_STREAM_ARE_CLEAN,
    regulatoryStream: [],
  };
}

export function top5PublishersAreLoadedWithError(filterFailureMessage) {
  return {
    type: TOP_5_PUBLISHERS_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function top5PublishersAreLoading() {
  return {
    type: TOP_5_PUBLISHERS_ARE_LOADING,
  };
}

export function top5PublishersAreLoaded(top5Publishers) {
  return {
    type: TOP_5_PUBLISHERS_ARE_LOADED,
    top5Publishers,
  };
}

export function top5CountriesAreLoadedWithError(filterFailureMessage) {
  return {
    type: TOP_5_COUNTRIES_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function top5CountriesAreLoading() {
  return {
    type: TOP_5_COUNTRIES_ARE_LOADING,
  };
}

export function top5CountriesAreLoaded(top5Countries) {
  return {
    type: TOP_5_COUNTRIES_ARE_LOADED,
    top5Countries,
  };
}

export function hotTopicsPerBusinessAreLoadedWithError(filterFailureMessage) {
  return {
    type: HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function hotTopicsAndBusinessUnitsAreLoading() {
  return {
    type: HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING,
  };
}

export function hotTopicsPerBusinessAreLoaded(hotTopicsAndBusinessUnits) {
  return {
    type: HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED,
    hotTopicsAndBusinessUnits,
  };
}

export function graphAggregationsAreLoadedWithError(filterFailureMessage) {
  return {
    type: GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function graphAggregationsAreLoading() {
  return {
    type: GRAPH_AGGREGATION_ARE_LOADING,
  };
}

export function graphAggregationsAreLoaded(
  graphAggregations,
  graphAggregationsTotalAmount
) {
  return {
    type: GRAPH_AGGREGATION_ARE_LOADED,
    graphAggregations,
    graphAggregationsTotalAmount,
  };
}

export function graphAggregationsDetailsAreLoadedWithError(
  filterFailureMessage
) {
  return {
    type: GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function graphAggregationsDetailsAreLoading() {
  return {
    type: GRAPH_AGGREGATION_DETAILS_ARE_LOADING,
  };
}

export function graphAggregationsDetailsAreLoaded(graphAggregationsDetails) {
  return {
    type: GRAPH_AGGREGATION_DETAILS_ARE_LOADED,
    graphAggregationsDetails,
  };
}

export function getDocumentIsLoadedWithError(filterFailureMessage) {
  return {
    type: GET_DOCUMENT_IS_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function getDocumentIsLoading() {
  return {
    type: GET_DOCUMENT_IS_LOADING,
  };
}

export function getDocumentIsLoaded(singleDocument) {
  return {
    type: GET_DOCUMENT_IS_LOADED,
    singleDocument,
  };
}

export function getSimilarDocumentIsLoadedWithError(filterFailureMessage) {
  return {
    type: GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR,
    filterFailureMessage,
  };
}

export function getSimilarDocumentIsLoading() {
  return {
    type: GET_SIMILAR_DOCUMENT_IS_LOADING,
  };
}

export function getSimilarDocumentIsLoaded(singleSimilarDocument) {
  return {
    type: GET_SIMILAR_DOCUMENT_IS_LOADED,
    singleSimilarDocument,
  };
}

export function applyCurrentFilter(currentFilter) {
  return {
    type: SET_CURRENT_FILTER,
    currentFilter,
  };
}

export function filterSuccessMessageRaised(filterSuccessMessage) {
  return {
    type: FILTER_SUCCESS_MESSAGE_RAISED,
    filterSuccessMessage,
  };
}

export function filterFailureMessageRaised(filterFailureMessage) {
  return {
    type: FILTER_FAILURE_MESSAGE_RAISED,
    filterFailureMessage,
  };
}

export function filterMessagesRestarted() {
  return {
    type: FILTER_MESSAGES_RESTARTED,
  };
}

export function generateNewsItemAction() {
  return {
    type: GENERATE_NEWS_ITEM,
  };
}

export function bookmarkDocument(
  usertoken,
  document_name,
  topic_id,
  reference_id,
  freeText,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  sortField
) {
  return (dispatch) => {
    axios({
      url: BOOKMARK_DOCUMENT,
      params: {
        usertoken,
        document_name,
        topic_id,
        reference_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(filterSuccessMessageRaised(response.data));
        dispatch(getDocument(usertoken, reference_id, topic_id));
        dispatch(
          getRegulatoryStream(
            usertoken,
            topic_id,
            freeText,
            topic_search_tags,
            publicationTypes,
            fromDate,
            toDate,
            publisherTypes,
            countries,
            "",
            0,
            10,
            sortField,
            ""
          )
        );
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function unbookmarkDocument(
  usertoken,
  document_name,
  topic_id,
  reference_id,
  freeText,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  sortField
) {
  return (dispatch) => {
    axios({
      url: UNBOOKMARK_DOCUMENT,
      params: {
        usertoken,
        document_name,
        topic_id,
        reference_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(filterSuccessMessageRaised(response.data));
        dispatch(getDocument(usertoken, reference_id));
        dispatch(
          getRegulatoryStream(
            usertoken,
            topic_id,
            freeText,
            topic_search_tags,
            publicationTypes,
            fromDate,
            toDate,
            publisherTypes,
            countries,
            "",
            0,
            10,
            sortField,
            ""
          )
        );
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function checkBookmarking(usertoken, reference_id) {
  axios({
    url: CHECK_BOOKMARKING,
    params: {
      usertoken,
      reference_id,
    },
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "aplication/json",
    },
  })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

export function generateNewsItem(usertoken, url, question) {
  return (dispatch) => {
    axios({
      url: GENERATE_NEWS,
      params: {
        usertoken,
        url,
        question,
      },
    })
      .then((response) => {
        dispatch(generateNewsItemAction(response.data.RegHub_response));
        dispatch(filterSuccessMessageRaised("TEST@@@@@."));
      })
      .catch((err) => {
        dispatch(
          filterFailureMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}
